export const selectMailMappers = (state) => state.mailMappers.mailMappersPag;
export const selectMailMappersLoading = (state) => state.mailMappers.loading;